export function replaceTranslationsVars(template, vars) {
    return Object.entries(vars).reduce((str, [key, val]) => {
        const regex = new RegExp(`\\[${key.toUpperCase()}\\]`, 'g');
        return str.replace(regex, String(val));
    }, template);
}
